/** Mute and the volume track. */

import type { Component } from 'solid-js';
import { Show } from 'solid-js';
import { setVolume, toggleMute } from '../../app/commands.ts';
import { clamp } from '../../lib/math.ts';
import { muted, volume } from '../../state/player.ts';
import { VolumeOff, VolumeOn } from '../icons/media.tsx';
import styles from './Transport.module.css';

export const Volume: Component = () => {
  let track!: HTMLDivElement;
  let dragging = false;

  const applyAt = (clientX: number): void => {
    const r = track.getBoundingClientRect();
    setVolume(clamp((clientX - r.left) / r.width, 0, 1));
  };

  const onDown = (e: PointerEvent): void => {
    dragging = true;
    track.setPointerCapture(e.pointerId);
    applyAt(e.clientX);
    e.preventDefault();
  };

  const onMove = (e: PointerEvent): void => {
    if (dragging) applyAt(e.clientX);
  };

  const stop = (): void => {
    dragging = false;
  };

  const width = (): string => `${(muted() ? 0 : volume()) * 100}%`;

  return (
    <div class={styles.vol} title="Volume (Up / Down)">
      <button
        type="button"
        class={styles.xbtn}
        aria-label={muted() ? 'Unmute' : 'Mute'}
        onClick={toggleMute}
      >
        <Show when={muted()} fallback={<VolumeOn />}>
          <VolumeOff />
        </Show>
      </button>
      <div
        class={styles.volTrack}
        data-testid="volume-track"
        ref={track}
        onPointerDown={onDown}
        onPointerMove={onMove}
        onPointerUp={stop}
        onPointerCancel={stop}
      >
        <div class={styles.volFill} style={{ width: width() }} />
      </div>
    </div>
  );
};
